export default __webpack_public_path__ + "navigation-examples-route-init-thumbnail-480-18bedeb0cba1275c1c86f61f0a314e41.png";